/**
 * Главный модуль функций установки значений в AMO поля
 * Импортирует и экспортирует функции из специализированных модулей
 */


import { 
    setAmoFieldValue,
    setAmoMultiselectValue,
    setAmoSimpleFieldValue,
    clearMultiselectField
} from './amoFieldsSetterCore.js';


import { 
    updateMultiselectMasterElements,
    updateMultiselectTitle,
    updateAmoModel,
    forceUpdateAmoFieldsValidation
} from './amoFieldsSetterHelpers.js';


export {
    setAmoFieldValue,
    setAmoMultiselectValue,
    setAmoSimpleFieldValue,
    clearMultiselectField,
    updateMultiselectMasterElements,
    updateMultiselectTitle,
    updateAmoModel,
    forceUpdateAmoFieldsValidation
}; 